module.exports = __webpack_public_path__ + "static/media/top-sport-video.74b030aa.mp4";